import { BoxProgramDetailsEntity } from "@/modules/boxProgrammation/entities/boxProgramEntity"
import { BoxSessionDetailsEntity } from "@/modules/boxSlotSession/entities/boxSessionEntity"
import { UserProgramDetailsEntity } from "@/modules/programs/entities/userProgramDetailsEntity"
import { ProgramType } from "@/modules/programs/types/programTypes"
import { ProgramInfiniteSessionEntity } from "@/modules/sessions/entities/programInfiniteSessionEntity"
import { ProgramOnOffSessionEntity } from "@/modules/sessions/entities/programOnOffSessionEntity"
import { ProgramBoxSessionForm } from "@/modules/sessions/sessionForm/components/programBoxSessionForm"
import { ProgramInfiniteOrProSessionForm } from "@/modules/sessions/sessionForm/components/programInfiniteOrProSessionForm"
import { ProgramOnOffSessionForm } from "@/modules/sessions/sessionForm/components/programOnOffSessionForm"

type ProgramSessionFormWrapperProps = {
  program: UserProgramDetailsEntity | BoxProgramDetailsEntity
  editedSession?: ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity | BoxSessionDetailsEntity
  editedBoxSlotId?: string
  dateSession?: string | number
  onFinish: () => void
}

export function ProgramSessionFormWrapper({
  program,
  editedSession,
  editedBoxSlotId,
  dateSession,
  onFinish,
}: ProgramSessionFormWrapperProps) {
  if (
    program instanceof UserProgramDetailsEntity &&
    [ProgramType.VIRTUAL, ProgramType.PRO].includes(program.type) &&
    (editedSession instanceof ProgramInfiniteSessionEntity || !editedSession) &&
    (typeof dateSession === "string" || typeof dateSession === "undefined")
  ) {
    return (
      <ProgramInfiniteOrProSessionForm
        program={program}
        editedSession={editedSession}
        dateSession={dateSession}
        onFinish={onFinish}
      />
    )
  } else if (
    program instanceof UserProgramDetailsEntity &&
    program.type === ProgramType.ONOFF &&
    (editedSession instanceof ProgramOnOffSessionEntity || !editedSession)
  ) {
    return (
      <ProgramOnOffSessionForm
        program={program}
        editedSession={editedSession}
        dateSession={dateSession}
        onFinish={onFinish}
      />
    )
  } else if (
    program instanceof BoxProgramDetailsEntity &&
    (editedSession instanceof BoxSessionDetailsEntity || !editedSession) &&
    (typeof dateSession === "string" || typeof dateSession === "undefined")
  ) {
    return (
      <ProgramBoxSessionForm
        boxProgram={program}
        editedSession={editedSession}
        dateSession={dateSession}
        editedBoxSlotId={editedBoxSlotId}
        onFinish={onFinish}
      />
    )
  } else {
    throw new Error("Invalid program type")
  }
}
